import type { BrandProfile } from './types';

/**
 * TechValley whitelabel profile. Selected at build time with `APP_BRAND=techvalley`.
 *
 * TODO(techvalley): the values below are PLACEHOLDERS — replace with TechValley's
 * real legal name, emails, hotline, marketing URLs, and assets before shipping.
 * Per-environment infra (Firebase project `production-partner-techvalley`,
 * Keycloak realm, API hosts) is NOT here — it lives in `.env.techvalley` and is
 * read via `src/config/env.ts`.
 *
 * Brand image assets live under `public/assets/brands/techvalley/` so they ship
 * alongside the VNETWORK assets without overwriting them.
 */
export const techvalley: BrandProfile = {
  id: 'techvalley',
  legalName: 'TECHVALLEY CO., LTD.',
  shortName: 'TechValley',
  appName: 'TechValley',
  ssoName: 'TechValley-ID',
  paymentReceiver: 'CONG TY TNHH TECHVALLEY', // TODO(techvalley): confirm bank beneficiary
  since: 2013, // TODO(techvalley): founding year for the copyright footer

  emails: {
    support: 'support@techvalley.biz',
    sales: 'sales@techvalley.biz',
    legal: 'legal@techvalley.biz',
    care: 'care@techvalley.biz',
  },

  hotline: '+84 (0) 966 589 300',

  urls: {
    docs: 'https://docs.techvalley.biz',
    openapi: 'https://openapi.techvalley.biz',
    postman: '', // TODO(techvalley): public Postman workspace, or '' if none
    privacyPolicy: 'https://techvalley.biz/privacy',
  },

  assets: {
    logo: '/assets/brands/techvalley/logo.png', // wide wordmark
    icon: '/assets/brands/techvalley/icon.ico', // square mark (app-shell + auth)
  },

  // gtmContainerId omitted — TechValley has no GTM container yet. Set its own
  // "GTM-XXXXXXX" here to enable tag injection; leaving it unset injects nothing.

  promos: {
    // TechValley does not run the VNETWORK WAF Free campaign.
    wafFree: false,
  },

  features: {
    payments: false,
    sso: false, // direct-grant form login only (no SSO redirect)
    credit: false,
    livechat: false,
    documentation: false,
    support: false,
    billing: false,
    apiKeys: false,
    affiliate: false,
  },

  // Reseller org customer_id in DataCentral — every signup on this whitelabel build is linked
  // under this reseller. Sourced from env (per-deployment; the id differs across dev/staging/prod)
  // and set in `.env.techvalley`. Undefined when unset, so the backend simply skips attribution.
  resellerCustomerId: Number(import.meta.env.APP_RESELLER_CUSTOMER_ID) || undefined,

  // TechValley opens only these categories: Compute, Kubernetes, Storage,
  // Networking & CDN, Security, Management (hides Media & Streaming, Databases,
  // Observability). Codenames map to categories.ts products.
  services: [
    'panda', 'cheetah', // compute (Enterprise Compute/bear hidden)
    'wolf', 'husky', // kubernetes
    'walrus', // storage
    'owl', // networking & cdn
    'cobra', 'lion', 'tiger', // security
    'griffin', 'unicorn', // management
  ],
};
